<form class="app-form">
  <div class="setup-content" id="step-4">
    <h4>{{ 'PIN_RESET.TITLE' | translate }}</h4>
    <p>{{ 'PIN_RESET.SUBTITLE' | translate }}</p>
    <div class="form-group">
      <label class="col-form-label">{{ 'PIN_RESET.PASSWORD' | translate }}</label>
      <div class="pin">
        <code-input
          class="code-input"
          id="passcode"
          [isCodeHidden]="true"
          [codeLength]="4"
          (codeChanged)="enterPasscode($event)"
        >
        </code-input>
      </div>
    </div>
    <div class="form-group">
      <label class="col-form-label">{{ 'PIN_RESET.CONFIRM_PASSWORD' | translate }}</label>
      <div class="pin">
        <code-input
          class="code-input"
          id="confirmPassword"
          [isCodeHidden]="true"
          [codeLength]="4"
          (codeChanged)="enterConfirmPasscode($event)"
        >
        </code-input>
      </div>
      @if (!passcodeValue().valid) {
      <div class="invalid">{{ 'MESSAGES.ERRORS.PASSWORDS_DO_NOT_MATCH' | translate }}</div>
      }
    </div>
    <div class="form-group mb-0">
      <button
        class="btn btn-gradient float-right mt-4"
        type="button"
        (click)="resetPassword()"
        [disabled]="!passcodeValue().valid"
      >
        <span>{{ 'PIN_RESET.RESET' | translate }}</span>
      </button>
      <button class="btn btn-outline-secondary float-right mr-4 mt-4" type="button">Back</button>
    </div>
  </div>
</form>
